import { useState } from "react";

export const TERMS_KEY = "mu_terms_agreed";

export function hasAgreedToTerms() {
  return localStorage.getItem(TERMS_KEY) === "1";
}

export default function TermsAgreement({ onAgree }) {
  const [agreed1, setAgreed1] = useState(false);
  const [agreed2, setAgreed2] = useState(false);
  const allChecked = agreed1 && agreed2;

  const handleAgree = () => {
    if (!allChecked) return;
    localStorage.setItem(TERMS_KEY, "1");
    onAgree();
  };

  return (
    <div style={s.container}>
      <div style={s.card}>
        <div style={s.iconWrap}>⚡</div>
        <h1 style={s.title}>크루픽 서비스 이용약관</h1>
        <p style={s.desc}>서비스를 이용하시기 전에 아래 약관을 확인하고 동의해 주세요.</p>

        <div style={s.policyBox}>
          <p style={s.policyText}>
            크루픽(CrewPick)은 스포츠 동호회 간 교류전 매칭을 지원하는 서비스입니다.{"\n\n"}
            서비스를 이용함으로써 다음 사항에 동의하는 것으로 간주됩니다.{"\n\n"}
            • 타 이용자를 존중하고 건전한 스포츠 문화를 조성합니다.{"\n"}
            • 허위 팀 정보 등록, 스팸성 신청을 하지 않습니다.{"\n"}
            • 개인정보는 매칭 서비스 제공 목적으로만 사용됩니다.{"\n"}
            • 계정 탈퇴 시 개인정보는 즉시 삭제됩니다.
          </p>
        </div>

        <CheckRow
          checked={agreed1}
          onChange={() => setAgreed1((v) => !v)}
          label="서비스 이용약관에 동의합니다 (필수)"
        />
        <CheckRow
          checked={agreed2}
          onChange={() => setAgreed2((v) => !v)}
          label="부적절한 콘텐츠나 욕설은 허용되지 않으며, 위반 시 서비스 이용이 제한될 수 있습니다 (필수)"
        />

        <button
          style={{ ...s.btn, opacity: allChecked ? 1 : 0.4, cursor: allChecked ? "pointer" : "default" }}
          onClick={handleAgree}
          disabled={!allChecked}
        >
          동의하고 시작하기
        </button>
      </div>
    </div>
  );
}

function CheckRow({ checked, onChange, label }) {
  return (
    <div style={s.checkRow} onClick={onChange}>
      <div style={{ ...s.checkbox, background: checked ? "#E24B4A" : "#fff", borderColor: checked ? "#E24B4A" : "#d1d5db" }}>
        {checked && (
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <polyline points="2,6 5,9 10,3" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
      </div>
      <span style={s.checkLabel}>{label}</span>
    </div>
  );
}

const s = {
  container:  { minHeight: "100dvh", background: "#f5f6fa", display: "flex", alignItems: "center", justifyContent: "center", padding: "24px 20px" },
  card:       { background: "#fff", borderRadius: 20, padding: "28px 24px 32px", maxWidth: 400, width: "100%", boxShadow: "0 4px 24px rgba(0,0,0,0.10)" },
  iconWrap:   { fontSize: 40, textAlign: "center", marginBottom: 14 },
  title:      { fontSize: 20, fontWeight: 800, color: "#111827", textAlign: "center", margin: "0 0 10px" },
  desc:       { fontSize: 13, color: "#6b7280", textAlign: "center", lineHeight: 1.6, margin: "0 0 18px" },
  policyBox:  { background: "#f5f6fa", borderRadius: 12, padding: "14px 16px", marginBottom: 20, maxHeight: 180, overflowY: "auto" },
  policyText: { fontSize: 12, color: "#6b7280", lineHeight: 1.8, whiteSpace: "pre-wrap", margin: 0 },
  checkRow:   { display: "flex", alignItems: "flex-start", gap: 10, marginBottom: 14, cursor: "pointer" },
  checkbox:   { width: 20, height: 20, borderRadius: 6, border: "2px solid", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: 1, transition: "background 0.15s, border-color 0.15s" },
  checkLabel: { fontSize: 13, color: "#374151", lineHeight: 1.5 },
  btn:        { width: "100%", padding: "15px", background: "#E24B4A", color: "#fff", border: "none", borderRadius: 12, fontSize: 16, fontWeight: 700, marginTop: 6, fontFamily: "inherit", transition: "opacity 0.15s" },
};
